import index from './autocomplete.mjs';
export { default as Autocomplete } from './autocomplete.mjs';
import index$1 from './button.mjs';
export { default as Button } from './button.mjs';
import index$2 from './carousel.mjs';
export { default as Carousel, OCarousel, OCarouselItem } from './carousel.mjs';
import index$3 from './checkbox.mjs';
export { default as Checkbox } from './checkbox.mjs';
import index$4 from './collapse.mjs';
export { default as Collapse, OCollapse } from './collapse.mjs';
import index$5 from './datepicker.mjs';
export { default as Datepicker } from './datepicker.mjs';
import index$6 from './datetimepicker.mjs';
export { default as Datetimepicker, ODatetimepicker } from './datetimepicker.mjs';
import index$7 from './dropdown.mjs';
export { default as Dropdown } from './dropdown.mjs';
import index$8 from './field.mjs';
export { default as Field } from './field.mjs';
import index$9 from './icon.mjs';
export { default as Icon } from './icon.mjs';
import index$a from './input.mjs';
export { default as Input } from './input.mjs';
import index$b from './inputitems.mjs';
export { default as Inputitems, OInputitems } from './inputitems.mjs';
import index$c from './loading.mjs';
export { default as Loading, LoadingProgrammatic } from './loading.mjs';
import index$d from './menu.mjs';
export { default as Menu, OMenu, OMenuItem, OMenuList } from './menu.mjs';
import index$e from './modal.mjs';
export { default as Modal, ModalProgrammatic, OModal } from './modal.mjs';
import index$f from './notification.mjs';
export { default as Notification, NotificationProgrammatic, ONotification } from './notification.mjs';
import index$g from './pagination.mjs';
export { default as Pagination } from './pagination.mjs';
import index$h from './radio.mjs';
export { ORadio, default as Radio } from './radio.mjs';
import index$i from './select.mjs';
export { default as Select } from './select.mjs';
import index$j from './skeleton.mjs';
export { OSkeleton, default as Skeleton } from './skeleton.mjs';
import index$k from './sidebar.mjs';
export { OSidebar, default as Sidebar } from './sidebar.mjs';
import index$l from './slider.mjs';
export { OSlider, OSliderTick, default as Slider } from './slider.mjs';
import index$m from './steps.mjs';
export { OStepItem, OSteps, default as Steps } from './steps.mjs';
import index$n from './switch.mjs';
export { OSwitch, default as Switch } from './switch.mjs';
import index$o from './table.mjs';
export { OTable, OTableColumn, default as Table } from './table.mjs';
import index$p from './tabs.mjs';
export { OTabItem, OTabs, default as Tabs } from './tabs.mjs';
import index$q from './timepicker.mjs';
export { default as Timepicker } from './timepicker.mjs';
import index$r from './tooltip.mjs';
export { default as Tooltip } from './tooltip.mjs';
import index$s from './upload.mjs';
export { OUpload, default as Upload } from './upload.mjs';
import { merge } from './helpers.mjs';
import { setVueInstance, setOptions, Programmatic, getOptions } from './config.mjs';
export { Plugin as Config, Programmatic as ConfigProgrammatic } from './config.mjs';
import { r as registerPlugin, a as registerComponentProgrammatic } from './plugins-0d853d1f.mjs';
export { u as useProgrammatic } from './plugins-0d853d1f.mjs';
export { s as OAutocomplete } from './Autocomplete-4aff0b4b.mjs';
export { s as OButton } from './Button-b2686fa8.mjs';
export { s as OCheckbox } from './Checkbox-87279cd9.mjs';
export { s as ODatepicker } from './Datepicker-9e285d92.mjs';
export { s as OLoading } from './Loading-2c4345ed.mjs';
export { s as OPagination, a as OPaginationButton } from './Pagination-0ed363fd.mjs';
export { s as ODropdown, a as ODropdownItem } from './DropdownItem-bf81cb78.mjs';
export { s as OField } from './Field-64a63988.mjs';
export { s as OIcon } from './Icon-e7ad13c9.mjs';
export { s as OInput } from './Input-5b84d324.mjs';
export { s as OSelect } from './Select-2ed6c9d4.mjs';
export { s as OTimepicker } from './Timepicker-a6098ce0.mjs';
export { s as OTooltip } from './Tooltip-c9093c86.mjs';
import 'vue';
import './InjectedChildMixin-52b9a851.mjs';
import './FormElementMixin-641da1dc.mjs';
import './InstanceRegistry-1e116bd6.mjs';
import './MatchMediaMixin-d91585a4.mjs';
import './trapFocus-f32fb08f.mjs';
import './CheckRadioMixin-f5b57344.mjs';
import './TabbedChildMixin-274f470d.mjs';
import './SlotComponent-11a269f3.mjs';
import './ssr-85c76d50.mjs';

var plugins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: index,
    Button: index$1,
    Carousel: index$2,
    Checkbox: index$3,
    Collapse: index$4,
    Datepicker: index$5,
    Datetimepicker: index$6,
    Dropdown: index$7,
    Field: index$8,
    Icon: index$9,
    Input: index$a,
    Inputitems: index$b,
    Loading: index$c,
    Menu: index$d,
    Modal: index$e,
    Notification: index$f,
    Pagination: index$g,
    Radio: index$h,
    Select: index$i,
    Skeleton: index$j,
    Sidebar: index$k,
    Slider: index$l,
    Steps: index$m,
    Switch: index$n,
    Table: index$o,
    Tabs: index$p,
    Timepicker: index$q,
    Tooltip: index$r,
    Upload: index$s
});

const Oruga = {
    install(app, options = {}) {
        setVueInstance(app);
        // Options
        const defaultConfig = getOptions();
        setOptions(merge(defaultConfig, options, true));
        // Components
        for (const componentKey in plugins) {
            registerPlugin(app, plugins[componentKey]);
        }
        // Config component
        registerComponentProgrammatic(app, 'config', Programmatic);
    }
};

export { Oruga as default };
